const Utils = { type: "Utils" };

const ExtendProperty = function(base, dist){
    for (let prop in dist){
        if(dist.hasOwnProperty(prop)){
            base[prop] = dist[prop];
        }
    }
}

/**** utils for manipulation with HTML ****/
Utils.Html =  { type: "Html" };
ExtendProperty(Utils.Html, {

    // copy to clipboard
    copyToClipboard: function (withMessage, event) {
        const text = event.target.innerText;
        let textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();

        let msgContainer = document.createElement("span");
        if(withMessage) {
            // message container
            msgContainer.style.backgroundColor = "red";
            msgContainer.style.color = "white";
            msgContainer.style.width = "50px";
            msgContainer.style.height = "20px";
            msgContainer.style.display = "none";
            msgContainer.style.padding = "2px";
            msgContainer.style.margin = "0 10px 0 10px";
            if (event.target.parentNode) {
                event.target.parentNode.insertBefore(msgContainer, event.target.nextSibling);
            }
        }

        try{
            document.execCommand("Copy");
            msgContainer.innerText = "Copied!";
            msgContainer.style.backgroundColor = "green";
            msgContainer.style.display = "block";
        }
        catch (err){
            msgContainer.innerText = "Try again!";
        }

        if(msgContainer)
            setTimeout(function(){ msgContainer.remove(); }, 500);
        textArea.remove();
    }

});

/**** utils Formatting ****/
Utils.format = { type: "Format" };
ExtendProperty(Utils.format, {

});

export default Utils;